import React, { useEffect, useState } from "react";
import { useCountdown } from "./../../../hooks/useCountdown";
import LeftRightPanel from "./../LeftRightPanel/LeftRightPanel";
import Timer from "../Timer/Timer";
import TimerHeader from "./TimerHeader";

import HandleSubmit from "../HandleSubmit";

import styles from "./timer.module.scss";

const TimerBlock = ({
    EVENT_TYPES,
    setIsModalOpen,
    sides,
    setQuarterSelected,
    timersPerQuarter,
    quarterSelected,
    timerSecondsSelected,
    setTimerSecondsSelected,
    setTimersPerQuarter,
    setEventDetailsToAdd,
    goals,
    setGoals,
    setIsEditing,
    setComponentToInsertInModal,
    isLiveTickerStaff,
    matchId,
    setMatchStatus,
    matchStatus,
    matchData,
    setMatchData,
    setEndConfirmationModalOpen,
    setEventsToShow,
    formatApiData,
    homePlayers,
    awayPlayers,
}) => {
    const [timeExpired, setTimeExpired] = useState(false);
    // useCountdown(
    //   timersPerQuarter["Q1"]?.quarterStarted,
    //   "Q1",
    //   timersPerQuarter,
    //   setTimersPerQuarter
    // );
    // useCountdown(
    //   timersPerQuarter["Q2"]?.quarterStarted,
    //   "Q2",
    //   timersPerQuarter,
    //   setTimersPerQuarter
    // );
    // useCountdown(
    //   timersPerQuarter["Q3"]?.quarterStarted,
    //   "Q3",
    //   timersPerQuarter,
    //   setTimersPerQuarter
    // );
    // useCountdown(
    //   timersPerQuarter["Q4"]?.quarterStarted,
    //   "Q4",
    //   timersPerQuarter,
    //   setTimersPerQuarter
    // );
    // useCountdown(
    //   timersPerQuarter["SO"]?.quarterStarted,
    //   "SO",
    //   timersPerQuarter,
    //   setTimersPerQuarter
    // );

    const timeExpiredHandler = () => {
        setTimeExpired(true);
    };

    useCountdown(
        timersPerQuarter[quarterSelected]?.quarterStarted,
        quarterSelected,
        timersPerQuarter,
        setTimersPerQuarter,
        timeExpiredHandler
    );

    const TOTAL_TIME_PLAYED = Object.values(timersPerQuarter)?.reduce(
        (acc, val) => {
            return acc + val?.timePlayed;
        },
        0
    );

    const timeExpiredSubmit = async (secondsPerPeriod) => {
        const tickerStatus = 0;
        const tickerSeconds = secondsPerPeriod;
        const tickerTimestamp = Date.now();
        const update = {
            tickerTimer: true,
            dhbMatchTimers: {
                tickerStatus,
                tickerSeconds,
                tickerTimestamp,
            },
        };
        await HandleSubmit(matchId, matchData, update, setMatchData);
    };

    useEffect(() => {
        if (timersPerQuarter[quarterSelected]?.timeLeft <= 0 && timeExpired) {
            const totalTimePerPeriod =
                timersPerQuarter[quarterSelected]?.totalTime;
            timeExpiredSubmit(totalTimePerPeriod);
            setTimeExpired(false);
        }
    }, [timeExpired]);

    return (
        <div className={styles["timer"]}>
            <LeftRightPanel
                TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                quarterSelected={quarterSelected}
                setEventDetailsToAdd={setEventDetailsToAdd}
                EVENT_TYPES={EVENT_TYPES}
                setIsModalOpen={setIsModalOpen}
                sideSelected={sides["home"]}
                sideNotSelected={sides["away"]}
                sides={sides}
                backgroundColor="#D2E5DB"
                direction="row"
                goals={goals}
                setGoals={setGoals}
                setIsEditing={setIsEditing}
                setComponentToInsertInModal={setComponentToInsertInModal}
                matchStatus={matchStatus}
                matchData={matchData}
            />
            <div id="timer-center" className={styles["timer__center-wrapper"]}>
                <TimerHeader
                    setQuarterSelected={setQuarterSelected}
                    timersPerQuarter={timersPerQuarter}
                    quarterSelected={quarterSelected}
                    matchData={matchData}
                    setComponentToInsertInModal={setComponentToInsertInModal}
                    setIsModalOpen={setIsModalOpen}
                    EVENT_TYPES={EVENT_TYPES}
                    setEventDetailsToAdd={setEventDetailsToAdd}
                    TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                />

                <Timer
                    totalTimePlayed={TOTAL_TIME_PLAYED}
                    quarterParams={timersPerQuarter[quarterSelected]}
                    timerSecondsSelected={timerSecondsSelected}
                    setTimerSecondsSelected={setTimerSecondsSelected}
                    quarterSelected={quarterSelected}
                    setTimersPerQuarter={setTimersPerQuarter}
                    isLiveTickerStaff={isLiveTickerStaff}
                    TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                    setEventDetailsToAdd={setEventDetailsToAdd}
                    EVENT_TYPES={EVENT_TYPES}
                    setIsModalOpen={setIsModalOpen}
                    sideSelected={sides["home"]}
                    sideNotSelected={sides["away"]}
                    sides={sides}
                    backgroundColor="#D2E5DB"
                    direction="row"
                    goals={goals}
                    setGoals={setGoals}
                    setIsEditing={setIsEditing}
                    setComponentToInsertInModal={setComponentToInsertInModal}
                    matchId={matchId}
                    setMatchStatus={setMatchStatus}
                    matchStatus={matchStatus}
                    matchData={matchData}
                    setMatchData={setMatchData}
                    setEndConfirmationModalOpen={setEndConfirmationModalOpen}
                    setEventsToShow={setEventsToShow}
                    formatApiData={formatApiData}
                    homePlayers={homePlayers}
                    awayPlayers={awayPlayers}
                />
            </div>
            <LeftRightPanel
                TOTAL_TIME_PLAYED={TOTAL_TIME_PLAYED}
                quarterSelected={quarterSelected}
                setEventDetailsToAdd={setEventDetailsToAdd}
                EVENT_TYPES={EVENT_TYPES}
                setIsModalOpen={setIsModalOpen}
                sideSelected={sides["away"]}
                sideNotSelected={sides["home"]}
                sides={sides}
                backgroundColor="#E8F0FA"
                direction="row-reverse"
                goals={goals}
                setGoals={setGoals}
                setIsEditing={setIsEditing}
                setComponentToInsertInModal={setComponentToInsertInModal}
                matchStatus={matchStatus}
                matchData={matchData}
            />
        </div>
    );
};

export default TimerBlock;
